module.exports = __webpack_public_path__ + "static/img/20.76a9f73.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/5/zh/20.png
// module id = mOK/
// module chunks = 0